import { createRoot } from 'react-dom/client'
import { App } from './App'
import { kernel } from '@omni/kernel'
import { switchOffOnce, switchNeedsOnOnce } from './off-by-default'
import { startUserPlugins, enabledMap } from './user-plugins'
import { createPluginsService } from './plugins-service'
import { createCurtain } from './shell/curtain'
import './index.css'

// 2026-10-18 (G3e): the one-canvas speed script measures a production host and needs the kernel handle that
// only dev builds expose (kernel.js). Only a build with VITE_EXPOSE_OMNI=1 sets it; `pnpm build` never does.
if (import.meta.env.VITE_EXPOSE_OMNI === '1') window.__omni = kernel

// omni.table-layout (now named "Grid") no longer switches omni.tables
// ("Table") off — both stay on together (2026-09-28, "activate previous
// Table back"). A browser that still carries the one-time switch-off from
// 6784775 (disabledReason 'superseded by omni.table-layout') gets Table
// turned back on, once; a person who disabled Table for their OWN reason
// keeps whatever reason they set, so this never fights that choice.
// before boot, so a plugin switched back on starts on this very load
switchNeedsOnOnce(kernel.store, localStorage)
// plugins (Plugin helper, the AI) switch plugins on through this; they cannot reach the kernel (2026-10-07)
kernel.services.provide('omni.plugins', createPluginsService(kernel))
// the host owns the curtain so it survives a kernel restart
kernel.services.provide('omni.curtain', createCurtain())
// taken before boot: a plugin switched on while plugins still start must win over the saved list (2026-10-07)
const startEnabled = enabledMap(kernel.store)
// before any plugin starts: on a first visit an off-by-default plugin must not start at all (G3, 2026-10-20)
kernel.boot({ beforeActivate: (store) => switchOffOnce(store, localStorage) }).then(() => {
  startUserPlugins(kernel.store, {
    startEnabled,
    storage: localStorage,
    authUrl: kernel.store.get('omni.auth')?.manifest.config?.url ?? `http://${location.hostname}:3020`,
    isSignedIn: async () => {
      const auth = window.__omni?.services?.getNow?.('omni.auth')
      return auth?.whenKnown ? Boolean(await auth.whenKnown) : false
    },
  })
  const tables = kernel.store.get('omni.tables')
  if (tables && !tables.enabled && tables.disabledReason === 'superseded by omni.table-layout') {
    kernel.store.setEnabled('omni.tables', true)
  }
})

createRoot(document.getElementById('root')).render(<App />)
